export const DEFAULT_AUTO_COMPLETE = 'off';

export const DEFAULT_TYPE = 'text';
